"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = Text;
var _theme = require("@a1s/theme");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Styled components
// -------------------------------------------------------------------------------------------------

// Make sure that we use styled-component's own typing for the `as` prop.
const Container = _styledComponents.default.p`
  ${({
  textSize,
  theme
}) => typeof textSize !== 'undefined' && (0, _theme.adjustFontSizeTo)(theme.fontSizes[textSize])}

  ${({
  font,
  theme
}) => typeof font !== 'undefined' && (0, _styledComponents.css)`
      font-family: ${theme.fonts[font]};
    `};

  ${({
  textAlign
}) => typeof textAlign !== 'undefined' && (0, _styledComponents.css)`
      text-align: ${textAlign};
    `};

  ${({
  textColor,
  theme
}) => typeof textColor !== 'undefined' && (0, _styledComponents.css)`
      color: ${theme.colors[textColor]};
    `};

  ${({
  weight
}) => typeof weight !== 'undefined' && (0, _styledComponents.css)`
      font-weight: ${weight};
    `};
`;

//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * A list of element names that we don't want to allow the `Text` component to be able to be used as.
 */
function Text({
  as,
  align,
  children,
  color,
  font,
  italic = false,
  size,
  testId,
  weight = 400
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    as: as,
    "data-testid": testId,
    font: font,
    isItalic: italic,
    textAlign: align,
    textColor: color,
    textSize: size,
    weight: weight
  }, children);
}